import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TrialBanner({ daysRemaining, module, onUpgrade }) {
  const navigate = useNavigate();
  const isUrgent = daysRemaining != null && daysRemaining <= 3;

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      navigate(`/subscription?module=${module || 'global'}`);
    }
  };

  if (daysRemaining == null) return null;

  return (
    <div className={`w-full px-4 py-2.5 flex items-center justify-between text-sm font-medium ${
      isUrgent
        ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white'
        : 'bg-gradient-to-r from-blue-500 to-purple-500 text-white'
    }`}>
      <div className="flex items-center gap-2">
        <Clock size={16} />
        <span>
          Free Trial: {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} remaining
        </span>
      </div>
      <button
        onClick={handleUpgrade}
        className="flex items-center gap-1 px-3 py-1 rounded-md bg-white/20 hover:bg-white/30 transition-colors text-sm font-semibold"
      >
        Upgrade Now
        <ArrowRight size={14} />
      </button>
    </div>
  );
}
